const { ccclass, property, menu, disallowMultiple } = cc._decorator;

/**
 * 果冻缓动效果*/
@ccclass
@disallowMultiple
@menu('Framework/缓动效果/ShakeTween2')
export default class ShakeTween2 extends cc.Component {


    private bPlayAni = false;

    protected start() {
        
    }

    /**
     * 播放
     * @param repeatTimes 重复次数
     */
    public play() {
        if (this.bPlayAni) {
            return;
        }
        this.bPlayAni = true;

        const width = 4;
        let once = cc.tween(this.node)
        .by(0.02, {x: width, y: width})
        .by(0.02, {x: 0, y: -width})
        .by(0.02, {x: -width, y: -width})
        .by(0.02, {x: -width, y: 0})
        .by(0.02, {x: 0, y: width})
        .by(0.02, {x: width, y: 0})
        .delay(1);
        cc.tween(this.node).repeatForever(once).start();
    }

    /**
     * 停止
     */
    public stop() {
        this.node.stopAllActions();
    }
}
